module.exports = __webpack_public_path__ + "img/avatar.cf806ba1.svg";